<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__top">
        <div class="footer__brand">
          <div class="footer__logo">摸鲸科技</div>
          <p class="footer__tagline">为创作而生，释放无限灵感<br>专业数字绘画工具与创作者生态</p>
        </div>
        <div class="footer__contact">
          <div class="footer__contact-inner">
            <div class="footer__contact-icon-wrap">
              <img src="@/assets/icons/email.svg" alt="" class="footer__contact-icon" />
            </div>
            <p class="footer__contact-text">联系我们<br>商务合作：yunying@huanci.ltd</p>
          </div>
        </div>
      </div>
      <div class="footer__divider"></div>
      <div class="footer__bottom">
        <div class="footer__copyright">
          <div class="footer_item">
            <img
              class="report_icon"
              :src="policeReportIcon"
            >
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33010802014520" rel="noreferrer" target="_blank">浙公网安备33010802014520号</a>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">浙ICP备2020044285号-6</a>
          </div>
          &copy; 2026摸鲸科技. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      policeReportIcon: require("@/assets/images/police.png")
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #141419;
  padding: 30px 0;
}

.footer__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer__brand {
  display: flex;
  flex-direction: column;
}

.footer__logo {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 16px;
}

.footer__tagline {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #9CA3AF;
}

.footer__contact {
  display: flex;
  align-items: center;
}

.footer__contact-inner {
  display: flex;
  align-items: center;
}

.footer__contact-icon-wrap {
  width: 40px;
  height: 40px;
  background-color: #1E1E2A;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.footer__contact-icon {
  width: 14px;
  height: auto;
}

.footer__contact-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #9CA3AF;
}

.footer__divider {
  height: 1px;
  background-color: #2A2A35;
  margin: 30px 0;
}

.footer__bottom {
  text-align: center;
}

.footer__copyright {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #9CA3AF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer_item {
  display: flex;
  flex-direction: row;
}
.report_icon {
  /* width: 20px; */
  height: 20px;
  margin-right: 6px;
}
a {
  margin-right: 10px;
}

@media (max-width: 1024px) {
  .footer {
    padding: 24px 0;
  }
  .footer__logo {
    font-size: 20px;
  }
  .footer__tagline {
    font-size: 13px;
  }
  .footer__contact-text {
    font-size: 13px;
  }
  .footer__divider {
    margin: 24px 0;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 24px 0;
  }
  .footer__top {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .footer__brand {
    align-items: flex-start;
  }
  .footer__logo {
    font-size: 18px;
  }
  .footer__tagline {
    font-size: 12px;
    line-height: 18px;
  }
  .footer__contact-inner {
    gap: 12px;
  }
  .footer__contact-icon-wrap {
    width: 40px;
    height: 40px;
  }
  .footer__contact-icon {
    width: 18px;
    height: 18px;
  }
  .footer__contact-text {
    font-size: 12px;
    line-height: 18px;
  }
  .footer__divider {
    margin: 20px 0;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 20px 0;
  }
  .footer__tagline,
  .footer__contact-text {
    font-size: 11px;
  }
  .footer__copyright {
    font-size: 11px;
  }
}
</style>
